"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _isObject = _interopRequireDefault(require("lodash/isObject"));

function getDelay(delay, type) {
  if (!delay) {
    return;
  }

  if ((0, _isObject["default"])(delay)) {
    return delay[type];
  }

  return delay;
}
/**
 * Use hover hook
 * Options:
 * @param delay = number or object { enter, exit }
 * @return [isHovering, hoverRef]
 */


function useHover() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var hoverRef = (0, _react.useRef)(null);
  var timeout = (0, _react.useRef)({
    enter: setTimeout(function () {}, 0),
    exit: setTimeout(function () {}, 0)
  });

  var onHoverLeave = function onHoverLeave() {
    var d = getDelay(delay, 'exit');

    if (d) {
      clearTimeout(timeout.current.enter);
      timeout.current.exit = setTimeout(function () {
        return setIsHovering(false);
      }, d);
    } else {
      setIsHovering(false);
    }
  };

  var onHoverEnter = function onHoverEnter() {
    var d = getDelay(delay, 'enter');

    if (d) {
      clearTimeout(timeout.current.exit);
      timeout.current.enter = setTimeout(function () {
        return setIsHovering(true);
      }, d);
    } else {
      setIsHovering(true);
    }
  };

  (0, _react.useEffect)(function () {
    var node = hoverRef.current;

    if (node) {
      node.addEventListener('mouseover', onHoverEnter);
      node.addEventListener('mouseleave', onHoverLeave);
      node.addEventListener('blur', onHoverLeave);
      return function () {
        node.removeEventListener('mouseover', onHoverEnter);
        node.removeEventListener('mouseleave', onHoverLeave);
        node.removeEventListener('blur', onHoverLeave);
      };
    }
  }, [hoverRef.current]);
  return [isHovering, hoverRef];
}

var _default = useHover;
exports["default"] = _default;